import Skeleton from "@mui/material/Skeleton";

function RevenueReportSkeleton() {
  return (
    <Skeleton className="rounded-2xl" variant="rectangular" height={228} />
  );
}

export default RevenueReportSkeleton;
